/**
 * Resolve which user is being forwarded during a call transfer (the held party /
 * original counterparty from the transfer target's perspective).
 */
export type TransferPartySession = {
  callerId: string
  calleeId: string
  peer?: { userId?: string | null } | null
}

export function resolveHeldPartyUserId(
  session: TransferPartySession,
  transferrerId: string,
): string {
  const peerId = session.peer?.userId?.trim()
  if (
    peerId &&
    peerId !== transferrerId &&
    !peerId.startsWith('group:')
  ) {
    return peerId
  }
  if (session.callerId === transferrerId) return session.calleeId
  if (session.calleeId === transferrerId) return session.callerId
  return session.callerId
}
